import { render, staticRenderFns } from "./editVideo.vue?vue&type=template&id=5e4221a5&scoped=true"
import script from "./editVideo.vue?vue&type=script&lang=js"
export * from "./editVideo.vue?vue&type=script&lang=js"
import style0 from "./editVideo.vue?vue&type=style&index=0&id=5e4221a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4221a5",
  null
  
)

export default component.exports